import { Button } from '@op/opds.opux';
import { Modal } from '@op/opds.opux-modal';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CancelPurchaseButton.module.scss';
import {
  APP_ELEMENT_ID,
  DEFAULT_PRODUCT_CARD_URL,
  MOBILE_PRODUCT_CARD_URL,
  PRODUCT_CARD_URLS,
} from '../../../constants';
import { getProductParam, isContentOnly, redirectTo } from '../../../utils';

export const CancelPurchaseButton: FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const cancelPurchase = () => {
    const product = getProductParam();
    const urls = PRODUCT_CARD_URLS[product];
    if (isContentOnly()) {
      redirectTo(urls?.mobile ?? MOBILE_PRODUCT_CARD_URL);
    } else {
      redirectTo(urls?.web ?? DEFAULT_PRODUCT_CARD_URL);
    }
  };

  return (
    <>
      <Button
        alternate
        onClick={() => {
          setIsModalOpen(true);
        }}
        data-testid='cancel-purchase-button'>
        {t('cancelPurchase.cancelPurchaseButton')}
      </Button>
      <Modal
        appElement={document.getElementById(APP_ELEMENT_ID) ?? undefined}
        showCloseButton={false}
        isOpen={isModalOpen}
        title={t('cancelPurchase.modalHeading')}
        onUpdate={({ open }: { open: boolean }) => {
          setIsModalOpen(open);
        }}
        footer={
          <div className={styles.buttons}>
            <Button
              compact
              onClick={() => {
                setIsModalOpen(false);
              }}
              data-testid='decline-cancel-btn'>
              {t('cancelPurchase.decline')}
            </Button>
            <Button
              compact
              onClick={cancelPurchase}
              data-testid='confirm-cancel-btn'>
              {t('cancelPurchase.confirm')}
            </Button>
          </div>
        }>
        {t('cancelPurchase.confirmText')}
      </Modal>
    </>
  );
};
